import styled, { css } from 'styled-components'

import { SvgImage } from 'components/SvgImage'

import { Color } from 'root-constants'

type TContainerProps = {
  $backgroundImage: string
  $padding?: string
}

type TBottomSectionProps = {
  $bottomSpacing?: string
  $hasBottomGradient?: boolean
}

type TSpeechBubbleProps = {
  $hasLongText: boolean
}

export const StyledIntroLoader = {
  Root: styled.div`
    height: 100vh;
    height: 100dvh;
  `,
  Container: styled.div<TContainerProps>`
    position: relative;
    overflow: hidden;

    max-width: 440px;
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;

    padding: ${({ $padding = '72px 16px 16px' }) => $padding};
    margin: 0 auto;

    background: url(${({ $backgroundImage }) => $backgroundImage});
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
  `,
  BackgroundImageArea: styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;

    min-width: 100%;
    min-height: 100%;
    aspect-ratio: 750 / 1536;
  `,
  SpeechBubble: styled.div<TSpeechBubbleProps>`
    position: absolute;
    right: 54%;
    bottom: 53.5%;
    transform: rotate(-7deg);
    transform-origin: bottom right;

    max-width: 160px;

    font-size: ${({ $hasLongText }) => ($hasLongText ? '14px' : '16px')};
    font-weight: 700;
    line-height: ${({ $hasLongText }) => ($hasLongText ? '18px' : '20px')};
    text-align: center;

    color: ${Color.INK_DARKEST};
    background-color: ${Color.BLUE_LIGHTEST};
    border-radius: 12px;

    padding: 8px 10px;
  `,
  SpeechBubbleTail: styled(SvgImage)`
    position: absolute;
    top: calc(100% - 1px);
    right: 20px;

    width: 27px;
    height: 17px;
  `,
  Title: styled.h1`
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;

    color: ${Color.WHITE};

    & strong {
      color: ${Color.GOLD_LIGHTER};
    }

    margin-bottom: 16px;
  `,
  Subtitle: styled.h3`
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;

    color: ${Color.WHITE};
  `,
  Description: styled.span`
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    text-transform: uppercase;

    color: ${Color.WHITE};
  `,
  Note: styled.span`
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 24px;
    text-align: center;

    color: ${Color.WHITE};

    margin-bottom: 24px;
  `,
  BottomSection: styled.div<TBottomSectionProps>`
    display: flex;
    flex-direction: column;
    margin-top: auto;
    padding-bottom: ${({ $bottomSpacing = '20vh' }) => $bottomSpacing};
    position: relative;
    z-index: 0;

    ${({ $hasBottomGradient, $bottomSpacing = '20vh' }) =>
      $hasBottomGradient &&
      css`
        margin-left: -24px;
        margin-right: -24px;
        padding: 96px 24px ${$bottomSpacing};
        background: linear-gradient(
          180deg,
          rgba(2, 10, 24, 0) 0.13%,
          rgba(2, 10, 24, 0.8) 37.06%
        );
      `}

    & > * {
      position: relative;
      z-index: 1;
    }
  `,
  GradientText: styled.span`
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;

    text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    background: linear-gradient(
      90deg,
      #bf9a3f 15.44%,
      #e8cb74 53.31%,
      #bf9a3f 86.39%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    margin-bottom: 42px;

    @media (max-height: 800px) {
      margin-bottom: 42px;
    }

    @media (max-height: 700px) {
      margin-bottom: 16px;
    }
  `,
}
